import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { FragmentNames, RawProfileLayoutAliases } from '../../codegen';
import BaseController from '../BaseController';
import { BrokerService, HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Inject } from '@odinjs/odin';
import { PanelAPI } from '@philips-internal/oswald-ui-components';
import { BS_ALTERNATIVE_LOGIN_VISIBILITY } from '../../constants/application-constants';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { MfaStatus } from 'src/interfaces/security-authentication';

@Controller({ component: RawProfileLayoutAliases.RAW_PROFILE_LAYOUT, fragment: FragmentNames.RAW_PROFILE_LAYOUT })
export default class RawProfileLayoutController extends BaseController {

  @Inject(RawProfileLayoutAliases.PANEL_CARD_ALTERNATIVE_LOGIN_CONTROL_VISIBILITY)
    alternativeLoginControlVisibilityPanelAPI!: PanelAPI;

  @Inject(RawProfileLayoutAliases.PANEL_CARD_SECURITY_CONTROL)
    securityAuthenticationVisibilityPanelAPI!: PanelAPI;

  @OnMount(RawProfileLayoutAliases.PANEL_ALTERNATIVE_LOGIN)
  handleMountPanelAlternativeLogin(): void {
    BrokerService.subscribeToTopic(BS_ALTERNATIVE_LOGIN_VISIBILITY, (visibility: boolean) => {
      this.alternativeLoginControlVisibilityPanelAPI.setVisible(visibility)
      this.alternativeLoginControlVisibilityPanelAPI.persistState();
    });
  }

  @OnMount({ target: RawProfileLayoutAliases.PANEL_SECURITY_AUTHENTICATION })
  onMountSecurityAuthentication(): void {
    HttpService.get(APPLICATION_ENDPOINTS.GET_AUTHENTICATION_CLIENT_STATUS, {})
      .then(response => {
        const mfaStatus = response.body as MfaStatus;
        this.setPanelSecurityAuthenticationVisibility(mfaStatus.isMfaEnabled);
      })
      .catch(() => {
        this.setPanelSecurityAuthenticationVisibility(false);
      });
  }

  private setPanelSecurityAuthenticationVisibility(isMfaEnabled: boolean): void{
    this.securityAuthenticationVisibilityPanelAPI.setVisible(isMfaEnabled)
    this.securityAuthenticationVisibilityPanelAPI.persistState();
  }

}
